module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-head"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('h2', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/03_Part01"
    }
  }, [_vm._v("Part I: The City")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: The Office")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: Man and Woman")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0